module.exports = __webpack_public_path__ + "img/Ellipse 1.8a531f8f.png";